function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#3E4C57",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.607 0a.3.3 0 0 1 .3.3v17.672a3 3 0 0 1-3 3H.3a.3.3 0 0 1-.3-.3v-2.984a.3.3 0 0 1 .3-.3h2.862a.3.3 0 0 0 .3-.3v-2.882a.3.3 0 0 1 .3-.3h2.91a.3.3 0 0 0 .3-.3V10.78a.3.3 0 0 1 .3-.3h3.218c-.063 0-.065-1.056-.008-3.168a.3.3 0 0 1 .3-.292h2.878a.3.3 0 0 0 .3-.3V3.833a.3.3 0 0 1 .3-.3h2.89a.3.3 0 0 0 .3-.3V.3a.3.3 0 0 1 .3-.3h2.857zM16.64 9.734l-.004.004-4.495 4.68-.886-.887a.3.3 0 0 0-.511.187l-.236 2.743a.3.3 0 0 0 .324.325l2.744-.236a.3.3 0 0 0 .186-.511l-.88-.88 4.679-4.496a.3.3 0 0 0 .008-.424l-.504-.505a.3.3 0 0 0-.425 0zM4.814 1.838a.3.3 0 0 0 .087.187l.88.88L1.103 7.4a.3.3 0 0 0-.008.424l.505.505a.3.3 0 0 0 .424 0l.004-.004 4.495-4.68.887.887a.3.3 0 0 0 .51-.186l.237-2.744a.3.3 0 0 0-.325-.324l-2.743.236a.3.3 0 0 0-.274.324z"
}));

var SvgFloor = function SvgFloor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFloor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/floor.0847e924.svg";
export { ForwardRef as ReactComponent };